"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcademyVenueInitialValues = void 0;
exports.AcademyVenueInitialValues = {
    venue: '',
    description: '',
    ageLimit: 12,
    trainingDay: 'MONDAY',
    fee: '0.00',
    registrationFee: '0.00',
    location: '',
    locationState: 'KUALALUMPUR',
    startDate: '',
    isTrialAvailable: false,
    trialFee: '0.00',
    maxTrial: 0,
};
//# sourceMappingURL=AdminFKA.js.map